import React from 'react';
import { BugOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip } from 'antd';
import { OUTPUT_LOGS_TOOLTIP_TITLE } from '@constants/search';
import { IPipeline } from '@redux/types/types';
import styles from './playgroundHeader.module.scss';
import QueryPipelineParams from '../queryPipelineParams/queryPipelineParams';
import SearchPipelineSelect from '../searchPipelineSelect/SearchPipelineSelect';

interface IPlaygroundHeaderProps {
  selectedPipeline?: IPipeline | null;
  isLoading?: boolean;
  onViewDebugLogs: () => void;
  params: Record<string, unknown>;
  onParamsChange: (params: IPlaygroundHeaderProps['params']) => void;
}

const PlaygroundHeader = ({
  selectedPipeline,
  isLoading,
  onViewDebugLogs,
  onParamsChange,
  params,
}: IPlaygroundHeaderProps) => {
  return (
    <Flex justify="space-between" align="center" gap="middle" className={styles.container}>
      <SearchPipelineSelect selectedPipeline={selectedPipeline} loading={isLoading} />
      <Flex align="center" className={styles.actions}>
        <Tooltip title={OUTPUT_LOGS_TOOLTIP_TITLE} placement="bottom">
          <Button type="text" icon={<BugOutlined />} onClick={onViewDebugLogs} />
        </Tooltip>
        <QueryPipelineParams onParamsChange={onParamsChange} params={params} />
      </Flex>
    </Flex>
  );
};

export default PlaygroundHeader;
